(function ($) {
    $(function () {
        const loadMoreButton = $('.js-load-more-news');

        if (!loadMoreButton.length) {
            return;
        }

        loadMoreButton.on('click', function (e) {
            e.preventDefault()

            const offset = $('.js-program-card').length;
            const max = parseInt($(this).data('max'));

            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                data: {
                    action: "load_more_news",
                    offset: offset
                },
                error: function (error) {
                    console.log(error)
                },
                success: function (response) {
                    if (response == 0) {
                        loadMoreButton.hide();
                        return;
                    }

                    $('.js-load-more-news-container').append(response).promise().done(function (e) {
                        $('.js-text-block').data("matchHeight", "false");
                        $.addMatchHeight($('.js-text-block:visible'));
                        $('.js-program-excerpt').data("matchHeight", "false");
                        $.addMatchHeight($('.js-program-excerpt:visible'));
                        $('.js-program-text-wrapper').data("matchHeight", "false");
                        $.addMatchHeight($('.js-program-text-wrapper:visible'));
                    });


                    if (max <= $('.js-program-card').length) {
                        loadMoreButton.hide();
                        return;
                    }

                },
            });
        });
    });
})(jQuery);